import MainImage from 'components/MainImage';
import Partner from 'components/Partner'
import ProductMenu from 'components/ProductMenu';
import URL from 'constants/url'
import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

function Main() {
  const refs = useRef([]);

  useEffect(() => {
    // Intersection Observer 콜백 함수
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 요소가 뷰포트에 들어오면 'visible' 클래스 추가
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // 관찰 중단
        }
      });
    };

    // Intersection Observer 설정
    const observerOptions = {
      root: null, // 뷰포트를 기준으로
      rootMargin: '0px',
      threshold: 0.4 // 10% 이상이 보일 때 콜백 실행
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // 모든 대상 요소에 대해 관찰 시작
    refs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      // 컴포넌트 언마운트 시 관찰 중단
      refs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <>
    {/* <MainImage/> */}
      <div className='front_wrap' ref={(el) => (refs.current[0] = el)}>
      
        <div className='front_main_sub'>
          <span>
            최적의 솔루션을 제공하는 <span className='strong_sub'>GIS</span> 컨설팅
          </span>
        </div>
        <img src='images/com_introduce.png' className='front_main_img' alt='이케이시스 메인 이미지' />
      </div>
      <div className='line_con'>
        <span className='main_line'></span>
      </div>
      <div className='front_second' ref={(el) => (refs.current[1] = el)}>
        <div className='front_second_main_img'>
          <div className='second_sub'>
            eKsys is Leading Company of New GIS Software Products
          </div>
          <div className='second_title'>
            창조적인 사고, 혁신적인 개발, 합리적인 기술을 제공 경영이념을 바탕으로
            IT Business 기업으로서,<br />
            방향성과 방법론에 대한 연구를 통해 그 기술력을 인정받고 있습니다.
          </div>
        </div>
      </div>
      
      <div className='padding_div' />

      <div className='front_wrap' ref={(el) => (refs.current[2] = el)}>
        <div className='wrap_img_con'>
          <img src='images/eksys_Iphone.png' className='front_main_img' alt='이케이시스 설명 이미지' />
        </div>
        <div className='front_main_sub intro'>
          {/* <div className='padding_div mobileno' /> */}
          <span>
            {/* 다양한 산업 분야로 GIS 컨설팅을 적용합니다 */}
            <span className='sky_blue_span'>GIS Engine 개발</span><span className='deep_blue_span'>Mobile 네비게이션</span><span className='green_span'>LBS 관련 서비스</span>분야에 끊임 없는 기술개발로 성장해 가고 있습니다.
            {/* 최적의 솔루션을 제공하는 <span className='strong_sub'></span>  */}
          </span>
        </div>
      </div>


      {/* <div className='work_process'>
        <div className='sub_div'>
          <img src='images/m01F_icon1.png' className='icon_img'/>
        교통약자이동지원
        <span className='sub_span'>
        교통약자를 위한 차량 배차 시스템으로 차량 통합 관리하는 관제시스템
        </span>
        </div>
       
        <div className='sub_div'>
        <img src='images/m01F_icon2.png' className='icon_img'/>
        스마트 택시
        <span className='sub_span'>
        택시 예약 및 배차 시스템으로 전화 및 App을 이용한 예약 기능 제공
        </span>
        </div>
        
        <div className='sub_div'>
        <img src='images/m01F_icon3.png' className='icon_img'/>
        GIS 솔루션
        <span className='sub_span'>
        차량 위치, 상태, 주행 거리, 시간등 이동 수단의 상태정보 및 운행 현황등을 종합 관리할 수 있는 시스템
        </span>
        </div>
        
      </div> */}
      <ProductMenu ref={(el) => (refs.current[3] = el)} />
      <div className='work_process2' ref={(el) => (refs.current[4] = el)}>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-01.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>교통약자이동지원</h5>
        </div>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-02.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>스마트 택시</h5>
        </div>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-03.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>GIS 솔루션</h5>
        </div>
        <div className='text_center'>
          <div className='img_con'>
            <img src='images/1-3-04.png' className='icon_img' />
          </div>
          <h5 className='img_h5'>SmartInfo</h5>
        </div>
      </div>

      <div className='button_wrap' ref={(el) => (refs.current[5] = el)}>
        <Link to={URL.PRODUCTS} className='detail_btn'>제품 상세보기</Link>
      </div>

      <div className='padding_div' />
      <Partner ref={(el) => (refs.current[6] = el)} />
      <div className='padding_div' />


      <div className='contact_div' ref={(el) => (refs.current[7] = el)}>
        <div className='second_sub mo' >
          {/* 궁금한 점이 있으신가요? */}
          제품에 대한 문의를 주세요.
          <br />
          보다 빠른 답변을 위해 노력하겠습니다.
        </div>
        {/* <span>보다 상세한 내용을 원하신다면</span> */}
        <Link to={URL.CONTACT} className='contact_btn'>CONTACT US</Link>
      </div>

      <div className='padding_div' />

    </>
  )
}

export default Main
